import React from "react"
import { Link } from "gatsby"

const Button = ({ to, variation, className, children }) => {
  if (variation === "secondary") {
    return (
      <div className="rounded-lg border border-medium-grey flex gap-3 px-4 py-2 shadow-button items-center cursor-pointer hover:text-blue hover:border-blue transition">
        {children}
      </div>
    )
  } else {
    return (
      <Link
        className={
          "text-sm text-blue hover:bg-soft-tones-blue-10 rounded p-1 " +
          className
        }
        to={to}
      >
        {children}
      </Link>
    )
  }
}

export default Button
